import { useEffect, useState } from 'react';
import { getIframeInfo, sendMessageToParent } from '../utils/iframeDetection.util';

export interface IframeInfo {
  isInIframe: boolean;
  canAccessParent: boolean;
  parentOrigin?: string;
}

/**
 * Custom hook for iframe detection and communication
 * @returns Object containing iframe information and utility functions
 */
export const useIframeDetection = () => {
  const [iframeInfo, setIframeInfo] = useState<IframeInfo | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Get initial iframe detection info
    const info = getIframeInfo();
    setIframeInfo(info);
    setIsLoading(false);
  }, []);

  const sendToParent = (message: any, targetOrigin?: string) => {
    if (iframeInfo?.isInIframe) {
      sendMessageToParent(message, targetOrigin);
    }
  };

  return {
    iframeInfo,
    isLoading,
    sendToParent,
    isInIframe: iframeInfo?.isInIframe || false,
    canAccessParent: iframeInfo?.canAccessParent || false
  };
};
